export class ThingsLocation{
    placeId: string;
    placeType: string;
    placeName: string;
    latitude: number;
    longitude: number;
    canEditLocation: boolean;

    constructor(placeId:string, 
        placeType:string, 
        placeName:string, 
        latitude: number, 
        longitude: number,
        canEditLocation: boolean){

        this.placeId = placeId;
        this.placeType = placeType;
        this.placeName = placeName;
        this.latitude = latitude;
        this.longitude = longitude;
        this.canEditLocation = canEditLocation;
    }
}